import { NodeNames } from '@farmersdog/constants';
import { Link } from '@farmersdog/corgi-x';

import {
  ComponentName,
  LayoutType,
  NodeType,
  type Blueprint,
  type Fragment,
} from '../types';

import { emailSentence } from './common/emailSentence';
import { zipSentence } from './common/zipSentence';
import { standardBlueprint } from './standardBlueprint';

export const pocOtherBlueprint: Blueprint = structuredClone(standardBlueprint);

pocOtherBlueprint.version = 'poc-other-blueprint';

const termsCheckboxSentence: Fragment = {
  name: 'termsCheckboxSentence',
  type: NodeType.branch,
  layout: LayoutType.block,
  input: {
    excludeFromProgress: true,
  },
  children: [
    {
      name: NodeNames.TermsAcceptance,
      type: NodeType.leaf,
      validation: NodeNames.TermsAcceptance,
      layout: LayoutType.block,
      component: ComponentName.CheckboxInput,
      input: {
        label: (
          <>
            and I agree to The Farmer’s Dog’s{' '}
            <Link href={'/content/terms'} target="_blank">
              Terms of Use
            </Link>{' '}
            and have read the{' '}
            <Link href={'/content/privacy'} target="_blank">
              Privacy Policy
            </Link>
            .
          </>
        ),
      },
    },
  ],
};

const me2Children = pocOtherBlueprint.root.children[0].children?.[2].children;

// Add new inputs to me2 page
me2Children?.push(zipSentence);
me2Children?.push(emailSentence);
me2Children?.push(termsCheckboxSentence);

// Remove me3 page
const meSectionChildren = pocOtherBlueprint.root.children[0].children;
meSectionChildren?.pop();
